/**
 * Inline skeleton for position list rows only (controls remain visible)
 */
export function PositionRowsSkeleton() {
  return (
    <div className="space-y-0.5">
      <div
        className="sticky z-10 mb-1 hidden rounded bg-gray-100 p-2 dark:bg-gray-700 md:grid md:grid-cols-[24px_2fr_80px_120px_1fr_120px_120px] md:items-center md:gap-4 md:px-2"
        style={{ top: '56px' }}
      >
        <div />
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Vessel
        </div>
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Activity
        </div>
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Last SIRE
        </div>
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Position
        </div>
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Date
        </div>
        <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Open Date
        </div>
      </div>

      <div
        className="sticky z-10 mb-1 rounded bg-gray-100 p-2 dark:bg-dark-700 md:hidden"
        style={{ top: '56px' }}
      >
        <div className="h-3 w-48 animate-pulse rounded bg-gray-200 dark:bg-dark-600" />
      </div>

      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <PositionRowSkeleton key={i} />
      ))}
    </div>
  );
}

function PositionRowSkeleton() {
  return (
    <div className="animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-dark-700 dark:bg-dark-800">
      <div className="px-1.5 py-1 md:hidden">
        <div className="flex gap-1">
          <div className="flex w-4 shrink-0 justify-center pt-0.5">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="min-w-0 flex-1 space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <div className="h-3.5 w-28 rounded bg-gray-200 dark:bg-dark-600" />
              <div className="h-4 w-4 rounded-full bg-gray-200 dark:bg-dark-600" />
              <div className="h-4 w-4 rounded-full bg-gray-200 dark:bg-dark-600" />
            </div>
            <div className="h-3 w-36 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="flex flex-wrap gap-2 border-t border-gray-100 pt-1 dark:border-dark-700">
              <div className="h-3 w-20 rounded bg-gray-200 dark:bg-dark-600" />
              <div className="h-3 w-20 rounded bg-gray-200 dark:bg-dark-600" />
              <div className="h-3 w-24 rounded bg-gray-200 dark:bg-dark-600" />
            </div>
          </div>
        </div>
      </div>

      <div className="hidden grid-cols-[24px_2fr_80px_120px_1fr_120px_120px] items-center gap-4 px-2 py-2 md:grid">
        <div className="flex justify-center">
          <div className="h-5 w-5 rounded bg-gray-200 dark:bg-dark-600" />
        </div>
        <div className="flex items-center gap-2">
          <div className="h-4 w-32 rounded bg-gray-200 dark:bg-dark-600" />
          <div className="h-4 w-10 rounded bg-gray-200 dark:bg-dark-600" />
        </div>
        <div className="flex justify-center">
          <div className="h-4 w-10 rounded bg-gray-200 dark:bg-dark-600" />
        </div>
        <div className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
        <div className="h-4 w-full max-w-[120px] rounded bg-gray-200 dark:bg-dark-600" />
        <div className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
        <div className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
      </div>
    </div>
  );
}

/**
 * @deprecated Use PositionRowsSkeleton instead for inline loading
 */
export function PositionSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-dark-700 dark:bg-dark-800">
      <div className="flex items-center gap-4 border-b border-gray-100 px-4 py-3 dark:border-dark-700">
        <div className="h-3 w-8 rounded bg-gray-200 dark:bg-dark-600" />
        <div className="hidden h-3 w-24 rounded bg-gray-200 dark:bg-dark-600 md:block" />
        <div className="hidden h-3 w-16 rounded bg-gray-200 dark:bg-dark-600 lg:block" />
        <div className="hidden h-3 w-20 rounded bg-gray-200 dark:bg-dark-600 lg:block" />
        <div className="h-3 w-20 rounded bg-gray-200 dark:bg-dark-600" />
        <div className="h-3 w-16 rounded bg-gray-200 dark:bg-dark-600" />
        <div className="h-3 w-16 rounded bg-gray-200 dark:bg-dark-600" />
      </div>

      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <div
          key={i}
          className="flex animate-pulse items-center gap-4 border-b border-gray-50 px-4 py-3 last:border-b-0 dark:border-dark-700/50"
        >
          <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
          <div className="hidden flex-1 items-center gap-2 md:flex">
            <div className="h-4 w-32 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-12 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="flex -space-x-2">
              <div className="h-5 w-5 rounded-full bg-gray-200 dark:bg-dark-600" />
              <div className="h-5 w-5 rounded-full bg-gray-200 dark:bg-dark-600" />
            </div>
          </div>
          <div className="hidden h-4 w-12 rounded bg-gray-200 dark:bg-dark-600 lg:block" />
          <div className="hidden h-4 w-20 rounded bg-gray-200 dark:bg-dark-600 lg:block" />
          <div className="flex-1 md:flex-none">
            <div className="mb-1 h-4 w-28 rounded bg-gray-200 dark:bg-dark-600 md:hidden" />
            <div className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
          <div className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
        </div>
      ))}
    </div>
  );
}
